import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_NIGHT, LINE_ITEM_DAY, propTypes, LINE_ITEM_HOUR } from '../../util/types';

import css from './OrderBreakdown.module.css';
import { daysBetween } from '../../util/dates';

const LineItemBasePriceMaybe = props => {
  const { lineItems, code, intl, booking, dayBasedPricing, dateBasedPricing } = props;
  const isNightly = code === LINE_ITEM_NIGHT;
  const isDaily = code === LINE_ITEM_DAY;
  const isHourly = code === LINE_ITEM_HOUR;

  const isDayBasedPricing = !!dayBasedPricing;
  const isDateBasedPricing = !!dateBasedPricing;
  // Find correct line-item for given code prop.
  // It should be one of the following: 'line-item/night, 'line-item/day', 'line-item/hour', or 'line-item/item'
  // These are defined in '../../util/types';
  const unitPurchase = lineItems.find(item => item.code === code && !item.reversal);

  // Member bookings replace the standard line-item/day with a
  // line-item/membership-rental-* line that this component doesn't render
  // (LineItemUnknownItemsMaybe handles it). Returning null lets the
  // breakdown drop the base-price row instead of crashing on undefined.
  if (!unitPurchase) return null;

  const seats = unitPurchase.seats ? unitPurchase.seats.toString() : null;

  const translationKey = isNightly
    ? 'OrderBreakdown.baseUnitNight'
    : isDaily
    ? isDayBasedPricing
      ? seats
        ? 'OrderBreakdown.baseUnitDayBasedSeatsPricing'
        : 'OrderBreakdown.baseUnitDayBasedPricing'
      : seats
      ? 'OrderBreakdown.baseUnitSeatsDay'
      : 'OrderBreakdown.baseUnitDay'
    : isHourly
    ? 'OrderBreakdown.baseUnitHour'
    : isDateBasedPricing
    ? 'OrderBreakdown.baseUnitDate'
    : 'OrderBreakdown.baseUnitQuantity';

  const start = booking?.attributes?.start;
  const end = booking?.attributes?.end;
  const bookingDaysBetween = daysBetween(start, end);

  const quantity = unitPurchase.quantity ? unitPurchase.quantity.toString() : null;
  const units = unitPurchase.units ? unitPurchase.units.toString() : null;
  const quantityOrUnits = units ? units : quantity;

  const unitPrice = unitPurchase ? formatMoney(intl, unitPurchase.unitPrice) : null;
  const total = unitPurchase ? formatMoney(intl, unitPurchase.lineTotal) : null;

  const seatsTranslationValueMaybe = seats ? { seats } : {};

  return quantityOrUnits && total ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage
          id={translationKey}
          values={{
            unitPrice,
            quantity: isDateBasedPricing
              ? bookingDaysBetween
              : isDayBasedPricing
              ? bookingDaysBetween
              : quantityOrUnits,
            ...seatsTranslationValueMaybe,
          }}
        />
      </span>
      <span className={css.itemValue}>{total}</span>
    </div>
  ) : null;
};

LineItemBasePriceMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  code: propTypes.lineItemUnitType.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemBasePriceMaybe;
